  
  import React from "react";
  import { AppBar, Box, Divider, IconButton, List, ListItem, ListItemText, Paper, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, Tooltip, Typography } from "@material-ui/core";
  import { ContactsOutlined, EmailOutlined, RadioOutlined } from "@material-ui/icons";
  import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
  import "./MenuSettings.less"
  import SecurityStatusMaintenance from "./SecurityStatusMaintenance/SecurityStatusMaintenance";
  import SecuritySubCategoryMaintenance from "./SecuritySubCategoryMaintenance/SecuritySubCategoryMaintenance";
  import SecurityCategoryMaintenance from "./SecurityCategoryMaintenance/SecurityCategoryMaintenance";
  import { a11yProps, getToolTipText } from "../../../utils/helper";
  import { grey } from "@material-ui/core/colors";
  import { apiRequest } from "../../../utils/api_service";
  import { API_URL } from "../../../constants/api";
  import { SECTIONS, TOOLTIP_LABEL } from "../../../constants/appConstants";
  
  function TabPanel(props) {
      const { children, value, index, ...other } = props;
    
      return (
        <div
          role={"tabpanel"}
          hidden={value !== index}
          id={`scrollable-prevent-tabpanel-${index}`}
          aria-labelledby={`scrollable-prevent-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography>{children}</Typography>
            </Box>
          )}
        </div>
      );
    }  
  export default class MenuSettings extends React.PureComponent {
      constructor(props) {
        super(props);
        this.state = {
          selectedMenu: 1,
          selectedIcon: 4,
          tooltip:[],
          menusList: [ {id: 1, name: "Security Status Maintenance"}, {id: 2, name: "Category Maintenance"}, {id: 3, name: "Sub Category Maintenance"}]
        };
      }
    
      componentDidMount() {
          this.getToolTipList();
          a11yProps(4);
      }
      
      /**
     * get security incident list
     */
    getToolTipList = () => {
      apiRequest({
        url: API_URL.masterData.GetLabels+"?sectionId="+SECTIONS.MENU_SETTINGS,
      }).then(({ data: List }) => {
         
        this.setState({
          tooltip: List
        });
      });
    };
  
      /**
     * render tab according tab selection
     * @returns
     */
    renderPage = () => {
      const { selectedMenu,tooltip } = this.state;
          switch (selectedMenu) {
          case 1:
              return <SecurityStatusMaintenance tooltip={tooltip} />;
          case 2:
              return <SecurityCategoryMaintenance tooltip={tooltip} />;
          case 3:
                  return <SecuritySubCategoryMaintenance tooltip={tooltip} />;
          }
    }
  
    menuIconClick = (selectedIcon) => {
      this.setState({ selectedIcon });
    }
  
    handleChange = (event, newValue) => {
      console.log(newValue)
      this.setState({ selectedIcon:  newValue});  };
  
  
      render() {
        const { selectedMenu, selectedIcon, menusList, tooltip } = this.state;
  
        return (
          <>
            <Table
              aria-labelledby={"tableMenuTitle"}
              size={"small"}
              aria-label={"configuration table"}
            >
              <TableHead>
                  <TableRow>
                  <TableCell
                      key={"configureHeader"}
                      className={"content-header"}
                      colSpan={2}
                  >
                      <div className={"content-header d-flex"}>
                      {" "}
                      <div
                          className={"col-xs-11"}
                          style={{ display: "inline-block", alignItems: "center" }}
                      >
                          {"Menu Settings"}
                      </div>
                      </div>
                  </TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  <>
                      <AppBar position={"static"} className={"white-tab-bar"} >
                          <Tabs
                              value={selectedIcon}
                              onChange={this.handleChange}
                              variant={"fullWidth"}
                              scrollButtons={"off"}
                              aria-label={"scrollable prevent tabs example"}
                              className={"white-tab-bar-tab"}
                          >
                              <Tab className={"menu-settings"} icon={
                                      <Tooltip title={getToolTipText(
                                          tooltip,
                                          TOOLTIP_LABEL.TENANT_SETTINGS
                                        )}
                                      >
                                          <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                                              <ContactsOutlined className={"menu-icon"} style={{ color: grey[50],  fontSize: "1.7rem" }} onClick={() => { this.menuIconClick(1) }}  />
                                          </IconButton>
                                      </Tooltip>
                                      } aria-label={"Tenant"} {...a11yProps(0)}
                              />
                              <Tab className={"menu-settings"} icon={ 
                                      <Tooltip title={getToolTipText(
                                          tooltip,
                                          TOOLTIP_LABEL.REQUEST_SETTINGS
                                        )}
                                      >
                                          <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                                              <RadioOutlined className={"menu-icon"} style={{ color: grey[50], fontSize: "1.7rem" }} onClick={() => { this.menuIconClick(2) }} />
                                          </IconButton>
                                      </Tooltip>
                                      } aria-label={"Request"} {...a11yProps(1)}
                              />
  
                              <Tab className={"menu-settings"} 
                                    icon={<Tooltip title={getToolTipText(
                                      tooltip,
                                      TOOLTIP_LABEL.COMMUNICATION_SETTINGS
                                    )}
                                          >
                                          <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                                              <EmailOutlined className={"menu-icon"} style={{ color: grey[50], fontSize: "1.7rem" }} onClick={() => { this.menuIconClick(3) }}  />
                                          </IconButton>
                                          </Tooltip>} aria-label={"Communication"} {...a11yProps(2)}
                              />
                              <Tab className={"menu-settings"}
                                    icon={<Tooltip title={getToolTipText(
                                      tooltip,
                                      TOOLTIP_LABEL.HSE_SETTINGS
                                    )}
                                          >
                                          <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                                              <LocalHospitalOutlinedIcon className={"menu-icon"} style={{color: grey[50],  fontSize: "1.7rem"}} onClick={() => { this.menuIconClick(4) }} />
                                          </IconButton>
                                          </Tooltip>} aria-label={"HSE"} {...a11yProps(3)}
                              />
                              <Tab className={"menu-settings"} icon={<Tooltip title={getToolTipText(
                                          tooltip,
                                          TOOLTIP_LABEL.SECURITY_SETTINGS
                                        )}
                                                                     >
                                          <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                                              {/* <img
                                                  onClick={() => { this.menuIconClick(5) }} 
                                                  style={{
                                                      width: "27px",
                                                      height: "28px",
                                                      fontSize: "1.7rem",
                                                      filter: "brightness(0) invert(1)"
                                                  }}
                                                  className={"menu-icon"}
                                                  src={Badge}
                                                  alt={"logo"}
                                              />                                     */}
                                              <svg xmlns={"http://www.w3.org/2000/svg"} 
                                              enable-background={"new 0 0 24 24"} height={"24px"} viewBox={"0 0 24 24"} width={"24px"} fill={"#000000"}
                                              ><rect fill={"none"} height={"24"} width={"24"} />
                                              <path d={"M14.5,12.59l0.9,3.88L12,14.42l-3.4,2.05l0.9-3.87l-3-2.59l3.96-0.34L12,6.02l1.54,3.64L17.5,10L14.5,12.59z M12,3.19 l7,3.11V11c0,4.52-2.98,8.69-7,9.93C7.98,19.69,5,15.52,5,11V6.3L12,3.19 M12,1L3,5v6c0,5.55,3.84,10.74,9,12c5.16-1.26,9-6.45,9-12 V5L12,1L12,1z"} />
                                              </svg>
                                          </IconButton>
                                                                     </Tooltip>} aria-label={"Security"} {...a11yProps(4)}
                              />
                          </Tabs>
                      </AppBar>
                      <TabPanel value={selectedIcon} index={0}>
                          {"Coming soon\r"}
                      </TabPanel>
                      <TabPanel value={selectedIcon} index={1}>
                          {"Coming soon\r"}
                      </TabPanel>
                      <TabPanel value={selectedIcon} index={2}>
                          {"Coming soon\r"}
                      </TabPanel>
                      <TabPanel value={selectedIcon} index={3}>
                          {"Coming soon\r"}
                      </TabPanel>
                      <TabPanel value={selectedIcon} index={4}>
                          <div className={"row configuration-container"}>                
                                  <div className={"col-xs-12 col-sm-12 col-md-3 col-lg-3"}>
                                  <div className={"addwidget-container"}>
                                      <div className={"row widget-content"}>
                                      <List
                                          component={"nav"}
                                          aria-label={"mailbox folders"}
                                          className={"ConfigureMenu"}
                                      >
                                          {" "}
                                          <>
                                          {menusList.map((menu, index) => {
                                              return (
                                              <>
                                                  <ListItem
                                                      key={index}
                                                      divider
                                                      button
                                                      selected={selectedMenu == menu.id}
                                                      onClick={() => this.setState({ selectedMenu: menu.id })}
                                                  >
                                                      <ListItemText fontSize={"small"} primary={menu.name} />
                                                  </ListItem>
                                                  <Divider />
                                              </>);
                                          })}
                                          </>
                                      
                                      </List>
                                      </div>
                                  </div>
                                  </div>
                                  <div className={"col-xs-12 col-sm-12 col-md-9 col-lg-9"}>
                                  <div className={"addwidget-container row"}>
                                      <Paper className={"col-xs-12"}>{this.renderPage()}</Paper>
                                  </div>
                                  </div>
                          </div>
                      </TabPanel>
                  </>
              </TableBody>
            </Table>
          </>
        );
      }
    }
    